"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuardianModule = void 0;
var error_helper_const_1 = require("@src/const/error-handling/error-helper.const");
var guardian_const_1 = require("@src/const/forms/guardian.const");
var input_output_helper_const_1 = require("@src/const/input-output-helper.const");
var input_mapping_const_1 = require("@src/const/input.mapping.const");
var element_generator_1 = require("@src/element-generator");
var inter_communication_service_1 = require("@src/services/inter-communication.service");
var module_handler_service_1 = require("@src/services/module-handler.service");
var object_service_1 = require("@src/services/object-service");
var translation_1 = __importDefault(require("@src/services/translation"));
var cash_dom_1 = __importDefault(require("cash-dom"));
var GuardianModule = /** @class */ (function () {
    function GuardianModule() {
        this.settings = {
            fields: ['familyName', 'givenName', 'email', 'phone', 'city', 'housenumber', 'street', 'zipcode'], //birthday
            optionalFields: [],
            matureAge: 18,
            showErrors: false,
        };
        this.interCom = object_service_1.ObjectService.getInstance(inter_communication_service_1.InterCommunicationService);
        this.elementGenerator = object_service_1.ObjectService.getInstance(element_generator_1.ElementGenerator);
    }
    GuardianModule.prototype.loadModule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _i, _b, field;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.guardianForm = this.filterGuardian(guardian_const_1._GuardianForm, this.settings);
                        if (!this.hasGuardianField('birthday')) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, (0, module_handler_service_1._BootstrapModuleIfNoChildModule)(this.$container, 'birthday', {
                                underAgeContracts: false,
                                minimumAge: this.settings.matureAge,
                                showErrors: false,
                            })];
                    case 1:
                        _a.birthdayModule = (_c.sent()).instance;
                        this.interCom.subscribeChildren(this).subscribe(function (data) {
                            if (data.event === 'validation' && data.value.valid) {
                                _this.guardianAge = data.value.data;
                            }
                        });
                        _c.label = 2;
                    case 2:
                        for (_i = 0, _b = Object.values(this.guardianForm); _i < _b.length; _i++) {
                            field = _b[_i];
                            if ((0, input_output_helper_const_1._GetFieldDomObj)(field, this.$container).length === 0) {
                                (0, input_output_helper_const_1._GenerateField)(this.$container, field);
                            }
                        }
                        this.elementGenerator.getGuardianPhonePrefixDropdown();
                        this.$container.on('keyup', function () {
                            _this.validateModule();
                        });
                        this.$container.on('change', function () {
                            _this.validateModule();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    GuardianModule.prototype.validateModule = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        // Validate using Partial<GuardianEvent> to allow missing fields initially.
        var rawResult = (0, input_output_helper_const_1._ValidateFields)(this.$container, {
            mappings: this.guardianForm,
            showErrors: this.settings.showErrors,
            animateToFirstError: false,
        });
        console.log("U18 validation result:", rawResult);
        if (!rawResult.valid) {
            return {
                valid: false,
                errorMessage: 'rawResult.errorMessage',
            };
        }
        var guardian = (_b = (_a = rawResult === null || rawResult === void 0 ? void 0 : rawResult.data) === null || _a === void 0 ? void 0 : _a.guardian) !== null && _b !== void 0 ? _b : {};
        var guardianEmailField = (0, cash_dom_1.default)("[data-get='".concat(guardian_const_1._GuardianForm.email.uid, "']"));
        var guardianPhoneField = (0, cash_dom_1.default)("[data-get='".concat(guardian_const_1._GuardianForm.phone.uid, "']"));
        if (this.bothContactFieldsOptional() && !((_c = guardian.email) === null || _c === void 0 ? void 0 : _c.trim()) && !((_d = guardian.phone) === null || _d === void 0 ? void 0 : _d.trim())) {
            if (this.settings.showErrors) {
                var errorMessage = translation_1.default.t('One of the fields has to be set.');
                (0, error_helper_const_1._AddErrorToDomObject)(guardianEmailField, errorMessage);
                (0, error_helper_const_1._AddErrorToDomObject)(guardianPhoneField, errorMessage);
            }
            return {
                valid: false,
                errorMessage: 'rawResult.errorMessage',
            };
        }
        var emailSameAsUnderage = !!((_e = guardian.email) === null || _e === void 0 ? void 0 : _e.trim()) && localStorage.getItem(input_mapping_const_1._AllMappings.email.uid) === guardian.email;
        if (emailSameAsUnderage) {
            (0, error_helper_const_1._AddErrorToDomObject)(guardianEmailField, translation_1.default.t('Guardian email has to be different than yours.'));
            return {
                valid: false,
                errorMessage: 'rawResult.errorMessage',
            };
        }
        else {
            (0, error_helper_const_1._RemoveStatusFromDomObject)(guardianEmailField);
        }
        if (this.birthdayModule) {
            var age = this.birthdayModule.validateModule();
            if (age === null || age === void 0 ? void 0 : age.valid) {
                guardian.birthday = age.data.birthday;
                guardian.age = age.data.age;
            }
            else {
                rawResult.valid = false;
            }
        }
        var guardianPhonePrefix = (_f = localStorage.getItem(guardian_const_1._GuardianTelephoneMobilePrefix.uid)) !== null && _f !== void 0 ? _f : '';
        var enteredPhone = ((_g = guardian.phone) !== null && _g !== void 0 ? _g : '').trim();
        if (guardianPhonePrefix.length > 0 && enteredPhone.startsWith('+')) {
            if (this.settings.showErrors) {
                (0, error_helper_const_1._AddErrorToDomObject)(guardianPhoneField, translation_1.default.t('Please enter the phone number without country prefix.'));
            }
            return {
                valid: false,
                errorMessage: 'rawResult.errorMessage',
            };
        }
        // if prefix exists: drop ONE leading "0" from entered phone
        var normalizedPhone = enteredPhone.replace(/^0/, '');
        var phone = guardianPhonePrefix.length > 0 ? "".concat(guardianPhonePrefix).concat(normalizedPhone) : enteredPhone;
        // Rebuild a complete GuardianEvent object.
        var completeGuardianData = {
            email: (guardian === null || guardian === void 0 ? void 0 : guardian.email) || '',
            familyName: (guardian === null || guardian === void 0 ? void 0 : guardian.familyName) || '',
            phone: phone,
            birthday: (guardian === null || guardian === void 0 ? void 0 : guardian.birthday) || '',
            age: (guardian === null || guardian === void 0 ? void 0 : guardian.age) || 0,
            givenName: (guardian === null || guardian === void 0 ? void 0 : guardian.givenName) || '',
            street: (guardian === null || guardian === void 0 ? void 0 : guardian.street) || '',
            city: (guardian === null || guardian === void 0 ? void 0 : guardian.city) || '',
            housenumber: (guardian === null || guardian === void 0 ? void 0 : guardian.housenumber) || '',
            zipcode: (guardian === null || guardian === void 0 ? void 0 : guardian.zipcode) || '',
            country: 'DE',
        };
        var result = {
            valid: rawResult.valid,
            data: completeGuardianData,
            errorMessage: 'rawResult.errorMessage',
        };
        if (this.oldState !== rawResult.valid) {
            this.interCom.sendEvent({
                module: this,
                event: 'validation',
                value: result,
            });
            this.oldState = rawResult.valid;
        }
        this.lastValidationResult = result;
        return result;
    };
    GuardianModule.prototype.filterGuardian = function (guardianForm, settings) {
        var _a;
        var optionalFields = (_a = settings.optionalFields) !== null && _a !== void 0 ? _a : [];
        return Object.fromEntries(this.getGuardianFields()
            .map(function (field) {
            var guardianField = guardianForm[field];
            var optional = optionalFields.includes(field);
            return guardianField
                ? [
                    field,
                    __assign(__assign({}, guardianField), { required: !optional, regex: optional && guardianField.regex ? new RegExp("^$|".concat(guardianField.regex.source)) : guardianField.regex }),
                ]
                : undefined;
        })
            .filter(Boolean));
    };
    GuardianModule.prototype.getGuardianFields = function () {
        var _a, _b;
        return Array.from(new Set(__spreadArray(__spreadArray([], ((_a = this.settings.fields) !== null && _a !== void 0 ? _a : []), true), ((_b = this.settings.optionalFields) !== null && _b !== void 0 ? _b : []), true)));
    };
    GuardianModule.prototype.hasGuardianField = function (field) {
        return this.getGuardianFields().includes(field);
    };
    GuardianModule.prototype.bothContactFieldsOptional = function () {
        var _a;
        var optionalFields = (_a = this.settings.optionalFields) !== null && _a !== void 0 ? _a : [];
        return optionalFields.includes('email') && optionalFields.includes('phone');
    };
    return GuardianModule;
}());
exports.GuardianModule = GuardianModule;
